import { render, staticRenderFns } from "./pkg33.vue?vue&type=template&id=ed4c5462&"
import script from "./pkg33.vue?vue&type=script&lang=js&"
export * from "./pkg33.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports